module.exports = __webpack_public_path__ + "static/media/logo.df4d9e41.png";